module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f6e219646fa4e019a7df8e769d903e57.png";